import { createRouter, createWebHashHistory } from 'vue-router'
const routes = [
  {
    path: '/wyyh_bocom',
    name: 'wyyh_bocom',
    meta:{
      title:"稳赢一号终身寿险保险产品计划BOCOM"
    },
    component: () => import('@/views/wyyh_bocom/index.vue')
  },
  {
    path: '/',
    name: 'bwhyf_bocom',
    meta:{
      title:"百万好运福保险产品计划BOCOM"
    },
    component: () => import('@/views/bwhyf_bocom/index.vue')
  },
  {
    path: '/fxkj_bocom',
    name: 'fxkj_bocom',
    meta:{
      title:"福享康健重大疾病保险产品计划BOCOM"
    },
    component: () => import('@/views/fxkj_bocom/index.vue')
  },
]

const router = createRouter({
  history:createWebHashHistory(process.env.BASE_URL),//采用hash路由模式
  routes
})

export default router
